<template>
    <div class="order-detail" v-if="personalData.orderPersonalData">
        <div class="common-box" v-show="type === 1">
            <div class="order-num c9">
                <div>订单编号：<span class="num-family">{{ personalData.orderNo }}</span></div>
                <div><i class="el-icon-download icon"></i><i class="el-icon-printer icon"></i></div>
            </div>
            <div class="name">{{ personalData.orderPersonalData.name }}的{{ personalData.type }}计划<img
                src="/img/bg/success-icon.png"
                class="status-icon"></div>
            <div class="c9">公益项目信息化管理系统</div>
        </div>
        <div class="order-info-container">
            <div class="common-box">
                <div class="o-title">基本信息</div>
                <div class=" order-info">
                    <img :src="personalData.orderPersonalData.photoUrl" class="photo">
                    <div class="info">
                        <div class="line"><span class="cae">姓名：</span>{{ personalData.orderPersonalData.name }}</div>
                        <div class="line"><span class="cae">性别：</span>{{ personalData.orderPersonalData.gender }}
                        </div>
                        <div class="line"><span class="cae">出生年月：</span>{{
                                personalData.orderPersonalData.birthday
                            }}
                        </div>
                        <!-- <div class="line"><span class="cae">身份证：</span>{{personalData.orderPersonalData.cardNo}}</div> -->
                        <div class="line"><span class="cae">身份证：</span>
                            {{ idCardType ? '******************' : personalData.orderPersonalData.cardNo }}
                            <img :src="idCardType ? imgUrl1 : imgUrl2" @click='changeIdcard' class="eye_class" alt="">
                        </div>
                        <div class="line"><span class="cae">类型：</span>{{ personalData.crimeType }}</div>
                        <div class="line"><span class="cae">状态：</span>{{ personalData.status }}</div>
                        <div class="order-list-item" v-if="personalWorkTypeData.length >= 3">
                            <div class="item">
                                <div class="pain">{{ personalWorkTypeData[0].cnt }}次</div>
                                <div class="btn one">{{ personalWorkTypeData[0].dataTypeName }}</div>
                            </div>
                            <div class="item">
                                <div class="pain">{{ personalWorkTypeData[1].cnt }}次</div>
                                <div class="btn two">{{ personalWorkTypeData[1].dataTypeName }}</div>
                            </div>
                            <div class="item">
                                <div class="pain">{{ personalWorkTypeData[2].cnt }}次</div>
                                <div class="btn three">{{ personalWorkTypeData[2].dataTypeName }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="qr-code-container">
                        <div class="ewm" id="qrcode"></div>
                        <!-- <img src="/img/bg/ewm.jpg" class="ewm"> -->
                        <div>档案编号：<span>{{ personalData.caseArchivedNo }}</span></div>
                        <div class="mb10">扫码可以预览案情</div>
                        <el-button type="primary" plain @click="getCaseArchivedDetail">档案详情</el-button>
                    </div>
                </div>
            </div>
            <div class="common-box">
                <div class="o-title">参与具体计划帮扶机构</div>
                <div class="radder-chart" v-if="radderShow">
                    <radder ref="radder"></radder>
                </div>
                <div style="height: 200px;display: flex;justify-content: center;align-items: center;" v-else>
                    <div class="avue-empty">
                        <div class="avue-empty__image" style="height: 50px;"><img
                            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                            alt=""></div>
                        <p class="avue-empty__desc">暂无数据</p>
                    </div>
                </div>
                <div class="radder-info">
                    <div class="item">
                        <div>具体计划数</div>
                        <div class="mt10 c6">{{ radderCntIndex }}</div>
                    </div>
                    <div class="item">
                        <div>完成情况</div>
                        <div class="mt10 c6">{{ radderDoneCntIndex }}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="档案详情" fullscreen append-to-body width="80%" :visible.sync="orderDetailVisible1">
            <pdf :info="caseDetail" :dosserId="dosserId" :type="2" @close="orderDetailVisible1 = false"></pdf>
        </el-dialog>
        <!-- <div class="order-info-container"> -->
        <div class="common-box">
            <div class="o-title">订单列表</div>
            <avue-crud :option="option" :cell-class-name="cellClassName" :table-loading="loading" v-model="orderForm"
                       :data="data" ref="crud" :page.sync="page" :permission="permissionList"
                       @search-change="searchChange"
                       @search-reset="searchReset" @selection-change="selectionChange" @row-update="rowUpdate"
                       @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange"
                       @on-load="onLoad"
                       @error="error">
                <template slot="menuLeft">
                    <el-button type="warning" size="small" plain icon="el-icon-download" v-if="permission.order_export"
                               @click="handleExport">导出
                    </el-button>
                </template>
                <template slot="residenceAddressLabel">
                    <span>详细地址：</span>
                    <div>
                        <el-checkbox v-model="checked" @change="asyncAddress">同步户籍</el-checkbox>
                    </div>
                </template>
                <template slot-scope="{row}" slot="status">
                    <el-progress :percentage="row.status" :status="row.status == 100 ? 'success' : ''"></el-progress>
                </template>
                <template slot-scope="{row}" slot="orderType">
                    <el-tag>{{ row.$orderType }}</el-tag>
                </template>
                <template slot-scope="{row}" slot="caseArchivedNo">
                    <div class="num-family">{{ row.caseArchivedNo }}</div>
                </template>
                <template slot-scope="{row}" slot="caseArchivedNumber">
                    <div class="num-family">{{ row.caseArchivedNumber }}</div>
                </template>
                <template slot-scope="{row}" slot="orderNo">
                    <div class="num-family">{{ row.orderNo }}</div>
                </template>
                <template slot="qsgxForm">
                    <kinship :isShowTitle="false" :list="orderForm.orderKinshipList" :orderId="orderForm.id"
                             @getList="getKinshipHandle"></kinship>
                </template>
                <template slot="shjwForm">
                    <relation :isShowTitle="false" :list="orderForm.orderRelationList" :orderId="orderForm.id"
                              @getList="getRelationHandle"></relation>
                </template>
                <template slot="initForm">
                    <orderinit :isShowTitle="false" :list="orderForm.orderInitialPlanList" :orderId="orderForm.id"
                               :orderType="orderForm.type" @getList="getorderInitialPlanList"></orderinit>
                </template>
                <template slot="gjfpzForm">
                    <orderjudicial :isShowTitle="false" :list="orderForm.starOrderJudicialList" :orderId="orderForm.id"
                                   @getList="getjudicialHandle"></orderjudicial>
                </template>
                <template slot-scope="{row}" slot="orderName">
                    <span @click="handleSuccessView2(row, 2)"> {{ row.orderName }}</span>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_detail"
                               @click.stop="handleView(scope.row, 1)">详情
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_region && scope.row.status == 0"
                               @click.stop="updateRegionHandle(scope.row)">区域分流
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_update && (scope.row.status == 0 || scope.row.status == 5 || scope.row.status == 20 || scope.row.status == 35)"
                               @click.stop="handleEdit(scope.row)">完善
                    </el-button>
                    <!-- 总中心审核初始订单 -->
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_examine && scope.row.status == 30"
                               @click.stop="handleView(scope.row, 2)">审核
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_dispatch && scope.row.status == 40"
                               @click.stop="$router.push(`/order/dispatch?id=${scope.row.id}`)">派单
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_dispatch && scope.row.isInitialPlanExpire == 1"
                               @click.stop="$router.push(`/order/dispatch?id=${scope.row.id}&expire=true`)">重新派单
                    </el-button>
                    <!-- 所有任务结束后总中心审核 -->
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_examine && scope.row.status == 60"
                               @click.stop="handleView(scope.row, 3)">审核
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small" v-if="permission.order_task"
                               @click.stop="handleJudicial(scope.row)">任务
                    </el-button>
                    <!--  -->
                    <!-- <el-link href="/img/xxx.pdf" type="primary" size="mini" target="_blank">查看报告</el-link> -->
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_task && (scope.row.status == 80 || scope.row.status == 90)"
                               @click.stop="handleView(scope.row, 4)">评价评分
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_task && scope.row.status == 100"
                               @click.stop="downLoadPdf(scope.row)">查看报告
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline" size="small"
                               v-if="permission.order_task && scope.row.status == 100"
                               @click.stop="handleSuccessView(scope.row, 1)">查看订单
                    </el-button>
                    <el-button type="text" icon="el-icon-circle-plus-outline"
                               v-if="permission.order_close_case && scope.row.isManualCase == 1" size="mini"
                               @click="handleView(scope.row, 1)">结案
                    </el-button>
                </template>
                <template slot="menuForm" slot-scope="{row,index,type}" v-if="orderForm.id">
                    <el-button pain size="small" @click="goToExamine(row, index, type)">生成初始计划单 提交总中心审核
                    </el-button>
                    <el-button pain size="small" @click.stop="printInitHandle">打印初始计划单
                    </el-button>
                    <el-button pain size="small" v-if="orderForm.starOrderJudicialList.length > 0"
                               @click.stop="pdfpzVisible = true">打印凭证
                    </el-button>
                    <el-button pain size="small" @click.stop="openSocialHandle">查看社会调查报告
                    </el-button>
                </template>
            </avue-crud>
            <el-dialog title="选择区域机构分流-完善信息" append-to-body width="500px" :visible.sync="updateOrderVisible"
                       custom-class="common-dialog">
                <avue-cascader class="w100" lazy :lazy-load="lazyLoad" placeholder="请选择区域" check-strictly
                               :show-all-levels="false"
                               :emit-path="false" :props="props" v-model="deptotion.regionalCode" @change="changeHandle"
                               size="mini"></avue-cascader>
                <avue-select class="mt20 w100" size="mini" v-if="deptotion.regionalCode" v-model="deptotion.improveDept"
                             placeholder="请选择分流机构" :props="{ label: 'deptName', value: 'id' }"
                             :dic="deptList"></avue-select>
                <div class="tac mt20">
                    <el-button type="primary" size="mini" @click="perfectHandle">分流</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="isMode == 1 ? '订单详情' : '审核'" append-to-body width="80%"
                       :visible.sync="orderDetailVisible"
                       v-if="orderDetailVisible" custom-class="common-dialog">
                <orderDetail :detail="detailInfo" :printBtn="isMode == 1" :examineBtn="isMode == 2"
                             :lastExamine="isMode == 3"
                             :pfBtn="isMode == 4" @close="orderDetailVisible = false; refreshChange()"></orderDetail>
            </el-dialog>
            <el-dialog title="初始计划单" append-to-body width="80%" :visible.sync="pdflVisible"
                       custom-class="common-dialog"
                       class="avue-dialog">
                <csPdf :info="orderForm" @close="pdflVisible = false"></csPdf>
            </el-dialog>
            <el-dialog title="公检司法凭证" append-to-body width="80%" :visible.sync="pdfpzVisible"
                       custom-class="common-dialog"
                       class="avue-dialog">
                <gjfPdf :info="orderForm" @close="pdfpzVisible = false"></gjfPdf>
            </el-dialog>
            <el-dialog title="社会调查报告" append-to-body width="100%" :visible.sync="pdflVisible1"
                       custom-class="common-dialog"
                       class="avue-dialog">
                <investpdf :info="orderForm" @close="pdflVisible1 = false"></investpdf>
            </el-dialog>
            <el-dialog title="任务" append-to-body width="100%" :visible.sync="taskVisible" v-if="taskVisible"
                       custom-class="common-dialog" class="avue-dialog" @close="refreshChange">
                <orderjudicial :isShowBtn="true" :isOpt="true" :isShowTitle="false" :orderId="detailInfo.id"
                               :list="detailInfo.starOrderJudicialList"></orderjudicial>
            </el-dialog>
            <el-dialog append-to-body width="80%" :visible.sync="pdfOnlinelVisible" custom-class="common-dialog">
                <reportpdf :info="detailInfo" @close="pdfOnlinelVisible = false"></reportpdf>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

import QRCode from 'peachill-qrcode';
import { getToken } from '@/util/auth';
import { getList, getOrderInfo, add, update, remove, auditPlanHandle, perfectRegional, getDeptListByRegionCode, personalWorkTypeData, specificPlanData } from "@/api/order/index";
import { getArchivesDetailByCardId } from "@/api/archives/index"
import { getDictTree } from "@/api/system/dictbiz"
import { getDictionary } from '@/api/system/dictbiz'
import radder from '@/components/chart/radder.vue'
import { dateFormat } from '@/util/date'
import { emptySurplus, serialize, getInfoFromIdCard, } from '@/util/util'
import jtPdf from '@/views/archives/components/jtjh-pdf.vue'
import investpdf from '@/views/archives/components/investigation-pdf.vue'
import pdf from '@/views/archives/components/order-detail-pdf.vue'
import csPdf from '@/views/archives/components/lzjh-pdf.vue'
import reportpdf from '@/views/archives/components/report-pdf.vue'
import gjfPdf from '@/views/archives/components/gjf-pdf.vue'
import { getArchivesDetailByOrderId } from '@/api/archives/index'
import { cardid, isvalidatemobile } from '@/util/validate'
import orderjudicial from '@/components/orderjudicial/index.vue'
import kinship from '@/components/kinship/index.vue'
import relation from '@/components/relation/index.vue'
import orderinit from '@/components/orderinit/index.vue'
import { getLazyTree, getDetail } from "@/api/base/region";
import orderDetail from './order-detail.vue'

export default {
    name: 'order-detail-test',
    components: {
        radder,
        pdf,
        csPdf,
        investpdf,
        jtPdf,
        reportpdf,
        orderjudicial,
        orderDetail,
        kinship,
        relation,
        orderinit,
        gjfPdf
    },
    data () {
        var checkCardid = (rule, value, callback) => {
            let list = cardid(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            let list = isvalidatemobile(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };
        return {
            dosserId: "",
            caseDetail: {},
            // 个人订单性情
            orderDetailVisible1: false,
            personalData: {},
            data: [],
            isMode: 1, // 1是详情 2、3是审核 4、是任务
            updateOrderVisible: false,
            props: {
                label: 'title',
                value: 'id'
            },
            deptotion: {
                orderId: '',
                regionalLevel: '',
                regionalCode: '',
                improveDept: ''
            },
            treeData: [],
            checked: false,
            selectionList: [],
            deptList: [],
            detailInfo: '', // 订单具体详情
            pdfpzVisible: false,
            starOrderStatusList: [],
            timer: null,
            qrcode: null,
            text: "",
            jtjhDetail: {},
            pdfljtVisible: false,
            // 列表订单详情
            orderDetailVisible: false,
            pdflVisible: false,
            pdflVisible1: false,
            pdfOnlinelVisible: false,
            type: 1,
            idCardType: true,
            imgUrl1: require('../../static/images/common/show.png'),
            imgUrl2: require('../../static/images/common/hide.png'),
            orderForm: {
                order: {},
                dossier: {
                    teenagersType: ''
                }
            },
            option: {
                tip: false,
                selection: true, // 是否多选的
                delBtn: false,
                editBtn: false,
                addBtn: false,
                align: 'center',
                border: true,
                selectClearBtn: false,
                dialogClickModal: false,
                searchMenuSpan: 6,
                searchIcon: true,
                searchIndex: 3,
                updateBtnText: '完善',
                searchLabelWidth: 100,
                menuWidth: 300,
                searchGutter: 0,
                column: [{
                    label: "订单号",
                    prop: "orderNo",
                    display: false,
                    search: true,
                    searchOrder: 5,
                    searchSpan: 6,
                    width: 154
                }, {
                    label: "案件编号",
                    prop: "caseArchivedNumber",
                    display: false,
                    width: 140,
                    search: true,
                    searchOrder: 6,
                    searchSpan: 6
                }, {
                    label: "案件档案编号",
                    prop: "caseArchivedNo",
                    display: false,
                    search: true,
                    width: 216,
                    // search: true,
                    searchOrder: 7,
                    searchSpan: 6
                }, {
                    label: "类型",
                    prop: "orderType",
                    display: false,
                    dataType: 'number',
                    type: 'select',
                    dicUrl: "/api/blade-system/dict-biz/dictionary",
                    dicQuery: {
                        code: 'work_type',
                    },
                    formatter: (row, value, label,) => {
                        return label
                    },
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    // search: true,
                    searchOrder: 4,
                    searchSpan: 6
                }, {
                    label: "姓名",
                    prop: "orderName",
                    display: false,
                    search: true,
                    searchOrder: 1,
                    searchSpan: 6
                }, {
                    label: "身份证号",
                    prop: "orderCardNo",
                    hide: true,
                    display: false,
                    search: false,
                    searchOrder: 2,
                    searchSpan: 6,
                    slot: true
                }, {
                    label: "性别",
                    prop: "orderGender",
                    display: false,
                    hide: true,
                    // search: true,
                    searchOrder: 3,
                    searchSpan: 6
                }, {
                    label: "颜色标注",
                    prop: "orderColor",
                    display: false,
                    hide: true,
                    // search: true,
                    searchOrder: 9,
                    searchSpan: 6
                }, {
                    label: "经办人",
                    prop: "orderCreateUserName",
                    // type: "tree",
                    // dicUrl: "/api/blade-order/order/getPublishUserList",
                    addDisplay: false,
                    editDisplay: false,
                    searchOrder: 2,
                    display: false,
                    span: 24,

                    // props: {
                    //     label: "userName",
                    //     value: "userId"
                    // },
                    rules: [{
                        required: true,
                        message: "请选择帮扶计划创建人",
                        trigger: "click"
                    }]
                }, {
                        label: "发布机构",
                        prop: "orderCreateDeptName",
                        // dicUrl: "/api/blade-order/order/getDeptList",
                        // props: {
                        //     label: "deptName",
                        //     value: "id"
                        // },
                        // formatter: (row, value, label, column) => {
                        //     return label
                        // },
                        display: false,
                        search: true,
                        searchOrder: 3,
                        searchSpan: 6
                    },
                    {
                        label: "状态",
                        prop: "status",
                        type: 'slider',
                        width: 100,
                        display: false
                    }, {
                        label: "发布时间",
                        prop: "createTime",
                        display: false
                    }, {
                        label: "完成时间",
                        prop: "finishTime",
                        display: false
                    },
                    {
                        label: "年龄",
                        prop: "orderAge",
                        hide: true,
                        display: false,
                        search: true,
                        searchOrder: 2,
                        searchSpan: 6
                    },
                    {
                        label: "时间",
                        prop: "timeRange",
                        type: "datetime",
                        format: "yyyy-MM-dd hh:mm:ss",
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        searchRange: true,
                        display: false,
                        hide: true,
                        search: true,
                        searchOrder: 10,
                        searchSpan: 6,
                        rules: [{
                            required: true,
                            message: "请输入时间",
                            trigger: "blur"
                        }]
                    },
                ],
                group: [{
                    label: '订单信息',
                    prop: 'orderInfo',
                    labelWidth: 120,
                    column: [{
                        label: "选择机构",
                        prop: "orderCreateDept",
                        // type: "select",
                        dataType: 'string',
                        type: 'tree',
                        checkStrictly: true,
                        leafOnly: false,
                        filterable: true,
                        cascaderItem: ['orderCreateUser'],
                        dicUrl: "/api/blade-system/dept/tree",
                        props: {
                            label: 'title'
                        },

                        rules: [{
                            message: "请选择机构",
                            trigger: "click"
                        }],
                        // change: ({ value }) => {
                        //     getPublishListDept().then(res => {
                        //         let obj = res.data.data.find(v => v.id == value)
                        //         if (obj) this.orderForm.orderCreateDeptName = obj.deptName
                        //     })
                        // }
                    },
                        {
                            label: "经办人",
                            prop: "orderCreateUser",
                            type: "select",
                            // dicUrl: "/api/blade-order/order/getPublishUserList",
                            dicUrl: "/api/blade-sorder/starorder/dep/{{key}}",
                            props: {
                                label: "name",
                                value: "id"
                            },
                            rules: [{
                                required: true,
                                message: "请选择发布人",
                                trigger: "change"
                            }],
                            // change: ({ value }) => {
                            //     getPublishList().then(res => {
                            //         let obj = res.data.data.find(v => v.userId == value)
                            //         if (obj) this.orderForm.orderCreateUserName = obj.userName
                            //     })
                            // }
                        },
                        {
                            label: "呼叫类型",
                            prop: "type1",
                            dataType: 'number',
                            type: 'select',
                            formatter: (row, value, label,) => {
                                return label
                            },
                            // dicUrl: "/api/blade-system/dict-biz/dictionary",
                            // dicQuery: {
                            //     code: 'work_type',
                            // },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            change: (value) => {
                                let column = this.option.group.find(v => v.prop == "gjf")
                                let column1 = this.findObject(this.option.group, "crimeSituation")
                                if (value.value == 2) {
                                    column.addDisplay = true
                                    column1.placeholder = "请输入案件描述"
                                } else {
                                    column.addDisplay = false
                                    column1.placeholder = "请输入需求描述"
                                }
                            },
                            rules: [{
                                required: true,
                                message: "请选择订单类型",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "五类青少年",
                            prop: "teenagersType",
                            bind: 'orderPersonalData.teenagersType',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dataType: 'number',
                            dicQuery: {
                                code: 'Five-youth_types'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择青少年类型",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "优先级",
                            prop: "priority",
                            bind: 'orderPersonalData.priority',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'priority'
                            },

                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择优先级",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "颜色标注",
                            prop: "orderColor1",
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Color'
                            },

                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择颜色标注",
                                trigger: "change"
                            }],
                        }
                    ]
                }, {
                    label: '基本信息',
                    prop: 'baseInfo',
                    labelWidth: 120,
                    column: [{
                        label: "头像",
                        prop: "photoUrl",
                        bind: 'orderPersonalData.photoUrl',
                        type: 'upload',
                        listType: 'picture-img',
                        loadText: '图片上传中，请稍等',
                        tip: '只能上传jpg/png图片，且不超过500kb',
                        // formslot: true,
                        action: '/api/blade-resource/oss/endpoint/put-file-attach',
                        propsHttp: {
                            res: 'data',
                            url: 'link'
                        },
                        data: {
                            fileName: 'avatar'
                        },
                        span: 24,
                        row: true

                    }, {
                        label: "姓名",
                        prop: "name",
                        bind: 'orderPersonalData.name',
                        rules: [{
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur"
                        }],
                        blur: () => {
                            // this.ayscHandle()
                        },
                    },
                        {
                            label: "身份证",
                            prop: "cardNo",
                            bind: 'orderPersonalData.cardNo',
                            hide: true,
                            rules: [{
                                required: true,
                                trigger: "blur",
                                validator: checkCardid
                            }],
                            blur: (value) => {
                                // this.ayscHandle()
                                if (!cardid(value.value)[0]) {
                                    let obj = getInfoFromIdCard(value.value)
                                    this.orderForm.birthday = obj.birthday
                                    this.orderForm.gender = obj.sex
                                    this.orderForm.orderPersonalData.birthday = obj.birthday
                                    this.orderForm.orderPersonalData.gender = obj.sex
                                }
                            },
                        },
                        {
                            label: "性别",
                            prop: "gender",
                            bind: 'orderPersonalData.gender',
                            type: 'select',
                            dataType: "number",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'sex'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择性别",
                                trigger: "blur"
                            }],
                            span: 8
                        },
                        {
                            label: "出生年月",
                            prop: "birthday",
                            bind: 'orderPersonalData.birthday',
                            type: "date",
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd hh:mm:ss",
                            hide: true,
                            rules: [{
                                required: true,
                                trigger: "blur",
                                message: "请选择出生年月"
                            }],
                            span: 8
                        },
                        {
                            label: "联系电话",
                            prop: "contact",
                            bind: 'orderPersonalData.contact',
                            rules: [{
                                required: true,
                                trigger: "blur",
                                validator: checkPhone
                            }],
                            span: 8
                        },
                        {
                            label: "籍贯",
                            prop: "nativePlace",
                            bind: 'orderPersonalData.nativePlace',
                            rules: [{
                                required: true,
                                message: "请输入籍贯",
                                trigger: "blur"
                            }],
                        }, {
                            label: "健康情况",
                            prop: "healthyState",
                            bind: 'orderPersonalData.healthyState',
                            dataType: 'number',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'healthy'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请输入籍贯",
                                trigger: "blur"
                            }],
                        },
                        {
                            label: '户籍所在区域',
                            prop: 'residenceProvince',
                            bind: 'orderPersonalData.residenceProvince',
                            type: 'select',
                            filterable: true,
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            cascaderItem: ['residenceCity', 'residenceDistrict'],
                            dicUrl: '/api/blade-system/region/select',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍省份",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceProvince = value.value
                                    this.orderForm.orderPersonalData.actualResidenceProvince = value.value
                                }
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'residenceCity',
                            bind: 'orderPersonalData.residenceCity',
                            type: 'select',
                            filterable: true,
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            // cascaderItem: ['residenceDistrict'],
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍城市",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceCity = value.value
                                    this.orderForm.orderPersonalData.actualResidenceCity = value.value
                                }
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'residenceDistrict',
                            filterable: true,
                            bind: 'orderPersonalData.residenceDistrict',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍区域",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceDistrict = value.value
                                    this.orderForm.orderPersonalData.actualResidenceDistrict = value.value
                                }
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        }, {
                            label: "详细地址",
                            prop: "residenceAddress",
                            bind: 'orderPersonalData.residenceAddress',
                            span: 24,
                            labelslot: true,
                            rules: [{
                                required: true,
                                message: "请输入详细地址",
                                trigger: "blur"
                            }],
                            blur: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidentialAddress = value.value
                                    this.orderForm.orderPersonalData.actualResidentialAddress = value.value
                                }
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        }, {
                            label: '居住所在区域',
                            prop: 'actualResidenceProvince',
                            bind: 'orderPersonalData.actualResidenceProvince',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            cascaderItem: ['actualResidenceCity', 'actualResidenceDistrict'],
                            dicUrl: '/api/blade-system/region/select',
                            span: 8,
                            filterable: true,
                            rules: [{
                                required: true,
                                message: "请选择居住省份",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'actualResidenceCity',
                            bind: 'orderPersonalData.actualResidenceCity',
                            type: 'select',
                            // cascaderItem: ['actualResidenceDistrict'],
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            filterable: true,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            rules: [{
                                required: true,
                                message: "请选择居住城市",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            label: '',
                            prop: 'actualResidenceDistrict',
                            bind: 'orderPersonalData.actualResidenceDistrict',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            filterable: true,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            rules: [{
                                required: true,
                                message: "请选择居住区域",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        },
                        {
                            label: "详细地址",
                            prop: "actualResidentialAddress",
                            bind: 'orderPersonalData.actualResidentialAddress',
                            span: 24,
                            rules: [{
                                required: true,
                                message: "请输入详细居住地址",
                                trigger: "blur"
                            }],
                            blur: () => {
                                // if (this.$refs.crud) {
                                //     this.$refs.crud.clearValidate()
                                // }
                            }
                        }
                    ]
                }, {
                    label: '涉案情况',
                    prop: 'shean',
                    labelWidth: 130,
                    column: [{
                        label: "案件类型",
                        prop: "crimeType",
                        // type: "select",
                        type: 'cascader',
                        dataType: "string",
                        emitPath: false,
                        showAllLevels: false,
                        // dicUrl: "/api/blade-system/dict-biz/dictionary",
                        // dicQuery: {
                        //     code: 'crime_types'
                        // },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            message: "请选择",
                            trigger: "click"
                        }],
                        // lazy:true
                    },
                        {
                            label: "涉案时间",
                            prop: "crimeTime",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                            rules: [{
                                required: true,
                                trigger: "blur"
                            }]
                        }, {
                            label: "涉案区域",
                            prop: "regionCode",
                            type: "cascader",
                            dicUrl: `/api/blade-system/region/lazy-tree?parentCode=00`,
                            props: {
                                label: "title"
                            },
                            checkStrictly: true,
                            showAllLevels: false,
                            lazy: true,
                            filterable: true,
                            lazyLoad: (node, resolve) => {
                                let list = [];
                                let stop_level = 4;
                                let level = node.level || 0;
                                let callback = () => {
                                    resolve((list || []).map(ele => {
                                        return Object.assign(ele, {
                                            leaf: level >= stop_level
                                        })
                                    }));
                                }
                                const parentCode = (level === 0) ? "00" : node.data.id;
                                getLazyTree(parentCode).then(res => {
                                    list = res.data.data;
                                    callback()
                                })
                            },
                            rules: [{
                                required: true,
                                message: "请选择涉案区域",
                                trigger: "blur"
                            }]
                        }, {
                            label: "涉案场所",
                            prop: "placeType",
                            span: 24,
                            type: 'select',
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'place_type'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请输入涉案场所",
                                trigger: "blur"
                            }],
                        },
                        {
                            label: "情况描述",
                            prop: "crimeSituation",
                            bind: 'crimeSituation',
                            type: 'textarea',
                            showWordLimit: true,
                            maxlength: 1000,
                            span: 24
                        },
                        // {
                        //     label: "危险因素",
                        //     prop: "hazard",
                        //     bind: 'hazard',
                        //     type: "select",
                        //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                        //     props: {
                        //         label: "dictValue",
                        //         value: "dictKey"
                        //     },
                        //     dicQuery: {
                        //         code: 'critical_factors_ype'
                        //     }
                        // }, {
                        //     label: "危急因素备注",
                        //     prop: "hazardRemark",
                        //     bind: 'hazardRemark'
                        // },
                        {
                            label: "紧急服务",
                            prop: "emergencyServices",
                            bind: 'emergencyServices',
                            type: "select",
                            dataType: "number",
                            dicData: [{
                                label: '需要',
                                value: 0
                            }, {
                                label: '不需要',
                                value: 1
                            }]
                        }, {
                            label: "紧急服务备注",
                            prop: "emergencyServicesRemarks",
                            bind: 'emergencyServicesRemarks'
                        },
                        // {
                        //     label: "案情概述",
                        //     prop: "summarize",
                        //     bind: 'summarize',
                        //     type: "textarea",
                        //     span: 24,
                        //     rules: [{
                        //         required: true,
                        //         message: "请填写",
                        //         trigger: "blur"
                        //     }]
                        // },
                        // {
                        //     label: "案情详情",
                        //     prop: "detail",
                        //     bind: 'detail',
                        //     type: "textarea",
                        //     span: 24,
                        //     rules: [{
                        //         required: true,
                        //         message: "请填写",
                        //         trigger: "blur"
                        //     }]
                        // },
                    ]
                }, {
                    label: '服务情况',
                    prop: 'fuwu',
                    labelWidth: 130,
                    column: [{
                        label: "曾经有使用相关服务记录",
                        labelWidth: 170,
                        prop: "isServiceSituation",
                        bind: 'orderPersonalData.isServiceSituation',
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '没有',
                            value: 0
                        }, {
                            label: '曾经有',
                            value: 1
                        }]
                    }, {
                        label: "曾经有注明",
                        prop: "serviceSituationRemarks",
                        bind: 'orderPersonalData.serviceSituationRemarks'
                    },
                        {
                            label: "现使用相关服务记录",
                            labelWidth: 170,
                            prop: "serviceSituationRecord",
                            bind: 'orderPersonalData.serviceSituationRecord',
                            type: "select",
                            dataType: "number",
                            dicData: [{
                                label: '没有',
                                value: 0
                            }, {
                                label: '现没有',
                                value: 1
                            }]
                        }, {
                            label: "现有注明",
                            prop: "serviceSituationNow",
                            bind: 'orderPersonalData.serviceSituationNow'
                        },
                    ]
                },
                    {
                        label: '社会调查',
                        prop: 'sociology',
                        column: [{
                            label: "调查时间",
                            prop: "surveyTime",
                            bind: 'orderSocialSurvey.surveyTime',
                            type: "date",
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd hh:mm:ss",
                            hide: true,
                            rules: [{
                                required: true,
                                trigger: "blur"
                            }]
                        }, {
                            label: "调查主体",
                            prop: "surveyMain",
                            bind: 'orderSocialSurvey.surveyMain',
                            rules: [{
                                required: true,
                                trigger: "blur"
                            }]
                        }, {
                            label: "调查方式",
                            prop: "surveyMethod",
                            bind: 'orderSocialSurvey.surveyMethod',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Investigation_method'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                trigger: "blur"
                            }]
                        },
                            {
                                label: "记录人",
                                prop: "record",
                                bind: 'orderSocialSurvey.record',
                                rules: [{
                                    required: true,
                                    trigger: "blur"
                                }]
                            },
                            {
                                label: "综合特质",
                                prop: "comprehensive",
                                bind: 'orderSocialSurvey.comprehensive',
                                type: "textarea",
                                span: 24,
                                placeholder: '提示：xxx体型稍胖，案主陈述性格较为内向、话较少'
                            }, {
                                label: "生活习惯",
                                prop: "livingHabits",
                                bind: 'orderSocialSurvey.livingHabits',
                                type: "textarea",
                                span: 24,
                                placeholder: '提示：xxx大多数时间都是宅在家里较少出去，爱打网络游戏，爱好打篮球（活动范围基本在居住地附近），生活作息叫规律'
                            }, {
                                label: "身高",
                                prop: "height",
                                bind: 'orderSocialSurvey.height',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'height'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "体重",
                                prop: "weight",
                                bind: 'orderSocialSurvey.weight',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'weight'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "情绪",
                                prop: "mood",
                                bind: 'orderSocialSurvey.mood',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'emotional'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "性格",
                                prop: "isCharacter",
                                bind: 'orderSocialSurvey.isCharacter',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'character'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },

                            }, {
                                label: '性格说明备注',
                                labelWidth: 120,
                                prop: 'isCharacterRemarks',
                                bind: 'orderSocialSurvey.isCharacterRemarks',
                                span: 12,

                            }, {
                                label: "是否有纹身",
                                prop: "isTattoo",
                                bind: 'orderSocialSurvey.isTattoo',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'there_tattoo'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "不良嗜好",
                                prop: "habits",
                                bind: 'orderSocialSurvey.habits',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'bad_hobby'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            },
                            {
                                label: "是否有手淫行为",
                                labelWidth: 115,
                                prop: "isMasturbation",
                                bind: 'orderSocialSurvey.isMasturbation',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Masturbation'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            },
                            {
                                label: "是否有观看淫秽视频行为",
                                labelWidth: 186,
                                prop: "isVideo",
                                bind: 'orderSocialSurvey.isVideo',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Obscene_video'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否有打架经历",
                                labelWidth: 115,
                                prop: "isFight",
                                bind: 'orderSocialSurvey.isFight',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Fighting_experience'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否经常出入娱乐场所",
                                labelWidth: 170,
                                prop: "isEntertainment",
                                bind: 'orderSocialSurvey.isEntertainment',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Entertainment_place'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否夜不归宿行为",
                                labelWidth: 129,
                                prop: "isWantTo",
                                bind: 'orderSocialSurvey.isWantTo',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Nocturnal_behavior'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "作息时间",
                                prop: "workTime",
                                bind: 'orderSocialSurvey.workTime',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Time_Table'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否有犯罪前科",
                                labelWidth: 116,
                                prop: "isCriminalRecord",
                                bind: 'orderSocialSurvey.isCriminalRecord',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Criminal_record'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否喜欢网络游戏",
                                labelWidth: 139,
                                prop: "isOnlineGame",
                                bind: 'orderSocialSurvey.isOnlineGame',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'network_game'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "在校处分情况",
                                labelWidth: 101,
                                prop: "isDisciplinary",
                                bind: 'orderSocialSurvey.isDisciplinary',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'punishment'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "是否有旷课行为",
                                labelWidth: 123,
                                prop: "isTruancy",
                                bind: 'orderSocialSurvey.isTruancy',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Absenteeism'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "法律法规认知程度",
                                labelWidth: 135,
                                prop: "isRegulations",
                                bind: 'orderSocialSurvey.isRegulations',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Awareness-laws_regulations'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "就读状况",
                                prop: "studentStatus",
                                bind: 'orderSocialSurvey.studentStatus',
                                type: "select",
                                dataType: "number",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Academic_status'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: "学校",
                                prop: "school",
                                bind: 'orderSocialSurvey.school'
                            },
                            {
                                label: "年级",
                                prop: "theGrade",
                                bind: 'orderSocialSurvey.theGrade'
                            },
                            {
                                label: "班级",
                                prop: "theClass",
                                bind: 'orderSocialSurvey.theClass'
                            },
                            {
                                label: "学籍号",
                                prop: "studentNo",
                                bind: 'orderSocialSurvey.studentNo'
                            },
                            {
                                label: "学习成绩",
                                prop: "studyResult",
                                bind: 'orderSocialSurvey.studyResult',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'academic_record'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            },
                            {
                                label: "学习经历",
                                prop: "studyExperience",
                                bind: 'orderSocialSurvey.studyExperience',
                                type: "textarea",
                                placeholder: "小学毕业于XXX中心小学；初中毕业于XXX中；目前就读于福州市XXX中学；XXX自述学习成绩一般，较少主动和同学交流互动，放学后都准时回家，偶尔早放学时会与同学一起打篮球。",
                                span: 24
                            },
                            {
                                label: "就业状况",
                                prop: "employmentStatus",
                                bind: 'orderSocialSurvey.employmentStatus',
                                type: "select",
                                dataType: "number",
                                dicData: [{
                                    label: '已就业',
                                    value: 0
                                }, {
                                    label: '未就业',
                                    value: 1
                                }]
                            }, {
                                label: "就业单位",
                                prop: "employmentUnit",
                                bind: 'orderSocialSurvey.employmentUnit'
                            },
                            {
                                label: '婚恋问题',
                                prop: 'marriageProblems',
                                bind: 'orderSocialSurvey.marriageProblems',
                                type: "select",
                                dicUrl: '/api/blade-system/dict-biz/dictionary',
                                dicQuery: {
                                    code: 'yes_no'
                                },
                                dataType: "number",
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: '婚恋备注',
                                prop: 'marriageProblemsRemark',
                                bind: 'orderSocialSurvey.marriageProblemsRemark',
                                span: 12,

                            },
                            {
                                label: '经济援助',
                                prop: 'financialAid',
                                bind: 'orderSocialSurvey.financialAid',
                                type: "select",
                                dicUrl: '/api/blade-system/dict-biz/dictionary',
                                dicQuery: {
                                    code: 'yes_no'
                                },
                                dataType: "number",
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                            }, {
                                label: '经济援助备注',
                                labelWidth: 110,
                                prop: 'financialAidRemark',
                                bind: 'orderSocialSurvey.financialAidRemark',
                                span: 12,
                            },
                            {
                                label: '家庭暴力问题',
                                labelWidth: 110,
                                prop: 'domesticViolence',
                                bind: 'orderSocialSurvey.domesticViolence',
                                dicUrl: '/api/blade-system/dict-biz/dictionary',
                                type: 'select',
                                dicQuery: {
                                    code: 'family_violence'
                                },
                                dataType: "number",
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                }
                            },
                            {
                                label: '家庭暴力备注',
                                labelWidth: 110,
                                prop: 'domesticViolenceRemark',
                                bind: 'orderSocialSurvey.domesticViolenceRemark',
                                span: 12,

                            },
                            {
                                label: "处理记录",
                                prop: "processingRecord",
                                bind: 'orderSocialSurvey.processingRecord',
                                type: 'textarea',
                                span: 24
                            }, {
                                label: "服务情况",
                                prop: "serviceSituation",
                                bind: 'orderSocialSurvey.serviceSituation',
                                type: 'textarea',
                                span: 24
                            },
                        ]
                    },
                    {
                        label: '家庭情况',
                        prop: 'family',
                        column: [{
                            label: '家庭类型',
                            prop: 'householdType',
                            bind: 'orderPersonalData.householdType',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'household_type'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true
                        }, {
                            label: "家庭教养",
                            prop: "familyUpbringing",
                            bind: 'orderPersonalData.familyUpbringing',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'parenting_pattern'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true
                        },
                            {
                                label: "家庭经济",
                                prop: "familyEconomy",
                                bind: 'orderPersonalData.familyEconomy',
                                type: "select",
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'Family-economic_status'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                                row: true
                            },
                            {
                                labelWidth: 0,
                                prop: 'familyNote',
                                bind: 'orderPersonalData.familyNote',
                                type: 'textarea',
                                span: 24,
                                placeholder: '简要说明'
                            }
                        ]
                    },
                    {
                        label: '亲属关系',
                        prop: 'qs',
                        column: [{
                            labelPosition: 'top',
                            prop: 'qsgx',
                            formslot: true,
                            span: 24
                        }]
                    },
                    {
                        label: '社会交往',
                        prop: 'jw',
                        column: [{
                            labelPosition: 'top',
                            prop: 'shjw',
                            formslot: true,
                            span: 24
                        }]
                    },
                    {
                        label: '在社区或单位表现',
                        prop: 'bx',
                        column: [{
                            labelWidth: 0,
                            prop: "performance",
                            type: 'textarea',
                            span: 24,
                            placeholder: "父亲XXX陈述，XXX与邻里关系融洽，口碑较好，村里大多数认为他是个乖顺的孩子。"
                        }]
                    },
                    {
                        label: '案主对今后发展期望',
                        prop: 'bx',
                        column: [{
                            labelWidth: 0,
                            prop: "expectations",
                            type: 'textarea',
                            span: 24,
                            placeholder: "提示：xxx对未来生涯规划没有明确目标，表示希望家庭和睦"
                        }]
                    },
                    {
                        label: '家庭对其将来回归社会的支持态度',
                        prop: 'bx',
                        column: [{
                            labelWidth: 0,
                            prop: "support",
                            type: 'textarea',
                            span: 24,
                            placeholder: "xxx父亲表示日后会多与孩子沟通，注重培养孩子乐观的心态,教育其明辨是非的能力，增强法律意识"
                        }]
                    },
                    {
                        label: '经综合分析，提出如下意见',
                        prop: 'bx',
                        column: [{
                            labelWidth: 0,
                            prop: "opinion",
                            type: 'textarea',
                            span: 24,
                            placeholder: "根据调查XXX个人情况、家庭状况、悔改表现、以及帮扶条件等情况。经综合分析，提出如下意见:案主XXX对本次事件有悔意及较强的心理压力，担忧返校后被同学和老师知道，影响学业和自尊心。由于家庭的教养方式对孩子有一定的控制倾向，导致XXX在主观行为规范、法律意识淡薄，有随从和从众的心理，缺乏主观见解和判断，但其父母较为年轻且收入较高较稳定，在对孩子教育引导和改善方面有一定的空间，建议对其犯罪行为从轻或减轻处罚。"
                        }]
                    },
                    {
                        label: '初始计划单',
                        prop: 'cs',
                        addDisplay: false,
                        column: [{
                            labelPosition: 'top',
                            prop: 'init',
                            formslot: true,
                            span: 24
                        }]
                    }, {
                        label: '公检法相关凭证',
                        prop: 'gjf',
                        addDisplay: false,
                        column: [{
                            labelPosition: 'top',
                            prop: 'gjfpz',
                            formslot: true,
                            span: 24
                        }]
                    }
                ]
            },
            addOption: {
                submitBtn: false,
                // emptyText:'关闭',
                emptyBtn: false,
                labelWidth: 138,
                group: [{
                    label: '订单信息',
                    prop: 'orderInfo',
                    column: [{
                        label: "选择机构",
                        prop: "orderCreateDept",
                        bind: 'order.orderCreateDept',
                        dataType: 'string',
                        type: 'tree',
                        checkStrictly: true,
                        leafOnly: false,
                        filterable: true,
                        dicUrl: "/api/blade-system/dept/tree",
                        cascaderItem: ['orderCreateUser'],
                        props: {
                            label: 'title'
                        },
                        rules: [{
                            message: "请选择机构",
                            trigger: "click"
                        }],
                    }, {
                        label: "经办人",
                        prop: "orderCreateUser",
                        bind: 'order.orderCreateUser',
                        type: "select",
                        dicUrl: "/api/blade-sorder/starorder/dep/{{key}}",
                        props: {
                            label: "name",
                            value: "id"
                        },
                        rules: [{
                            required: true,
                            message: "请选择发布人",
                            trigger: "change"
                        }],
                    },
                        {
                            label: "呼叫类型",
                            prop: "type",
                            bind: 'order.type',
                            dataType: 'number',
                            type: 'select',
                            // dicUrl: "/api/blade-system/dict-biz/dictionary",
                            // dicQuery: {
                            //     code: 'work_type',
                            // },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            formatter: (row, value, label,) => {
                                return label
                            },
                            change: (value) => {
                                let column = this.addOption.group.find(v => v.prop == "gjf")
                                let column1 = this.findObject(this.addOption.group, "crimeSituation")
                                if (value.value == 2) {
                                    column.display = true
                                    column1.placeholder = "请输入案件描述"
                                } else {
                                    column.display = false
                                    column1.placeholder = "请输入需求描述"
                                }
                            },
                            rules: [{
                                required: true,
                                message: "请选择订单类型",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "五类青少年",
                            prop: "teenagersType",
                            bind: 'orderPersonalData.teenagersType',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dataType: 'number',
                            dicQuery: {
                                code: 'Five-youth_types'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择青少年类型",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "优先级",
                            prop: "priority",
                            bind: 'orderPersonalData.priority',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'priority'
                            },

                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择优先级",
                                trigger: "change"
                            }],
                        },
                        {
                            label: "颜色标注",
                            prop: "orderColor1",
                            bind: 'order.orderColor',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Color'
                            },

                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择颜色标注",
                                trigger: "change"
                            }],
                        }
                    ]
                }, {
                    label: '基本信息',
                    prop: 'baseInfo',
                    column: [{
                        label: "头像",
                        prop: "photoUrl",
                        bind: 'orderPersonalData.photoUrl',
                        type: 'upload',
                        listType: 'picture-img',
                        loadText: '图片上传中，请稍等',
                        tip: '只能上传jpg/png图片，且不超过500kb',
                        // formslot: true,
                        action: '/api/blade-resource/oss/endpoint/put-file-attach',
                        propsHttp: {
                            res: 'data',
                            url: 'link'
                        },
                        data: {
                            fileName: 'avatar'
                        },
                        span: 24,
                        row: true
                    }, {
                        label: "姓名",
                        prop: "name",
                        bind: 'orderPersonalData.name',
                        rules: [{
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur"
                        }],
                        blur: () => {
                            this.ayscHandle()
                        },
                    },
                        {
                            label: "身份证",
                            prop: "cardNo",
                            bind: 'orderPersonalData.cardNo',
                            hide: true,
                            rules: [{
                                required: true,
                                trigger: "blur",
                                validator: checkCardid
                            }],
                            blur: (value) => {
                                this.ayscHandle()
                                if (!cardid(value.value)[0]) {
                                    let obj = getInfoFromIdCard(value.value)
                                    this.orderForm.birthday = obj.birthday
                                    this.orderForm.gender = obj.sex
                                    this.orderForm.orderPersonalData.birthday = obj.birthday
                                    this.orderForm.orderPersonalData.gender = obj.sex
                                }
                            },
                        },
                        {
                            label: "性别",
                            prop: "gender",
                            bind: 'orderPersonalData.gender',
                            type: 'select',
                            dataType: "number",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'sex'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请选择性别",
                                trigger: "blur"
                            }],
                            span: 8
                        },
                        {
                            label: "出生年月",
                            prop: "birthday",
                            bind: 'orderPersonalData.birthday',
                            type: "date",
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd",
                            hide: true,
                            rules: [{
                                required: true,
                                trigger: "blur",
                                message: "请选择出生年月"
                            }],
                            span: 8
                        },
                        {
                            label: "联系电话",
                            prop: "contact",
                            bind: 'orderPersonalData.contact',
                            rules: [{
                                required: true,
                                trigger: "blur",
                                validator: checkPhone
                            }],
                            span: 8
                        },
                        {
                            label: "籍贯",
                            prop: "nativePlace",
                            bind: 'orderPersonalData.nativePlace',
                            rules: [{
                                required: true,
                                message: "请输入籍贯",
                                trigger: "blur"
                            }],
                        }, {
                            label: "健康情况",
                            prop: "healthyState",
                            bind: 'orderPersonalData.healthyState',
                            dataType: 'number',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'healthy'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            rules: [{
                                required: true,
                                message: "请输入籍贯",
                                trigger: "blur"
                            }],
                        },
                        {
                            label: '户籍所在区域',
                            prop: 'residenceProvince',
                            bind: 'orderPersonalData.residenceProvince',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            filterable: true,
                            cascaderItem: ['residenceCity', 'residenceDistrict'],
                            dicUrl: '/api/blade-system/region/select',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍省份",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceProvince = value.value
                                    this.orderForm.orderPersonalData.actualResidenceProvince = value.value
                                }
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'residenceCity',
                            bind: 'orderPersonalData.residenceCity',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            filterable: true,
                            cascaderItem: ['residenceDistrict'],
                            // cascaderIndex: 0,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍城市",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceCity = value.value
                                    this.orderForm.orderPersonalData.actualResidenceCity = value.value
                                }
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'residenceDistrict',
                            bind: 'orderPersonalData.residenceDistrict',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            filterable: true,
                            // cascaderIndex: 0,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            // change: (value) => {
                            //     if (value.value) {
                            //         this.code = value.value
                            //         this.getDeptHandle()
                            //     }
                            // },
                            rules: [{
                                required: true,
                                message: "请选择户籍区域",
                                trigger: "blur"
                            }],
                            change: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidenceDistrict = value.value
                                    this.orderForm.orderPersonalData.actualResidenceDistrict = value.value
                                }
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        }, {
                            label: "详细地址",
                            prop: "residenceAddress",
                            bind: 'orderPersonalData.residenceAddress',
                            span: 24,
                            rules: [{
                                required: true,
                                message: "请输入详细地址",
                                trigger: "blur"
                            }],
                            labelslot: true,
                            blur: (value) => {
                                if (this.checked) {
                                    this.orderForm.actualResidentialAddress = value.value
                                    this.orderForm.orderPersonalData.actualResidentialAddress = value.value
                                }
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        }, {
                            label: '居住所在区域',
                            prop: 'actualResidenceProvince',
                            bind: 'orderPersonalData.actualResidenceProvince',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            cascaderItem: ['actualResidenceCity', 'actualResidenceDistrict'],
                            dicUrl: '/api/blade-system/region/select',
                            span: 8,
                            labelslot: true,
                            rules: [{
                                required: true,
                                message: "请选择居住省份",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            prop: 'actualResidenceCity',
                            bind: 'orderPersonalData.actualResidenceCity',
                            type: 'select',
                            cascaderItem: ['actualResidenceDistrict'],
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            filterable: true,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            rules: [{
                                required: true,
                                message: "请选择居住城市",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        },
                        {
                            labelWidth: 0,
                            placeholder: '请选择',
                            label: '',
                            prop: 'actualResidenceDistrict',
                            bind: 'orderPersonalData.actualResidenceDistrict',
                            type: 'select',
                            props: {
                                label: 'name',
                                value: 'code'
                            },
                            // cascaderIndex: 0,
                            filterable: true,
                            dicUrl: '/api/blade-system/region/select?code={{key}}',
                            span: 8,
                            rules: [{
                                required: true,
                                message: "请选择居住区域",
                                trigger: "blur"
                            }],
                            change: () => {
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        },
                        {
                            label: "详细地址",
                            prop: "actualResidentialAddress",
                            bind: 'orderPersonalData.actualResidentialAddress',
                            span: 24,
                            rules: [{
                                required: true,
                                message: "请输入详细居住地址",
                                trigger: "blur"
                            }],
                            blur: () => {
                                // if (this.$refs.addform) {
                                //     this.$refs.addform.clearValidate()
                                // }
                            }
                        }
                    ]
                }, {
                    label: '涉案情况',
                    prop: 'shean',
                    column: [{
                        label: "案件类型",
                        prop: "crimeType",
                        bind: 'order.crimeType',
                        // type: "select",
                        type: 'cascader',
                        dataType: "string",
                        // checkStrictly:true,
                        showAllLevels: false,
                        emitPath: false,
                        // dicUrl: "/api/blade-system/dict-biz/dictionary",
                        // dicQuery: {
                        //     code: 'crime_types'
                        // },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            message: "请选择",
                            trigger: "click"
                        }],
                        change: (val) => {
                            console.log(val)
                        }
                    },
                        {
                            label: "涉案时间",
                            prop: "crimeTime",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                            rules: [{
                                required: true,
                                trigger: "blur"
                            }]
                        }, {
                            label: "涉案区域",
                            prop: "regionCode",
                            type: "cascader",
                            dicUrl: `/api/blade-system/region/lazy-tree?parentCode=00`,
                            props: {
                                label: "title"
                            },
                            checkStrictly: true,
                            showAllLevels: false,
                            lazy: true,
                            filterable: true,
                            lazyLoad: (node, resolve) => {
                                let list = [];
                                let stop_level = 4;
                                let level = node.level || 0;
                                let callback = () => {
                                    resolve((list || []).map(ele => {
                                        return Object.assign(ele, {
                                            leaf: level >= stop_level
                                        })
                                    }));
                                }
                                const parentCode = (level === 0) ? "00" : node.data.id;
                                getLazyTree(parentCode).then(res => {
                                    list = res.data.data;
                                    callback()
                                })
                            },
                            change: () => {

                            },
                            rules: [{
                                required: true,
                                message: "请选择涉案区域",
                                trigger: "blur"
                            }]
                        },
                        {
                            label: "涉案场所",
                            prop: "placeType",
                            type: 'select',
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'place_type'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            span: 24,
                            rules: [{
                                required: true,
                                message: "请输入涉案场所",
                                trigger: "blur"
                            }],
                        },
                        {
                            label: "情况描述",
                            prop: "crimeSituation",
                            bind: 'order.crimeSituation',
                            type: 'textarea',
                            showWordLimit: true,
                            maxlength: 10000,
                            span: 24
                        },
                        // {
                        //     label: "危险因素",
                        //     prop: "hazard",
                        //     bind: 'order.hazard',
                        //     type: "select",
                        //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                        //     props: {
                        //         label: "dictValue",
                        //         value: "dictKey"
                        //     },
                        //     dicQuery: {
                        //         code: 'critical_factors_ype'
                        //     }
                        // }, {
                        //     label: "危急因素备注",
                        //     prop: "hazardRemark",
                        //     bind: 'order.hazardRemark',
                        // },
                        {
                            label: "紧急服务",
                            prop: "emergencyServices",
                            bind: 'order.emergencyServices',
                            type: "select",
                            dataType: "number",
                            dicData: [{
                                label: '需要',
                                value: 0
                            }, {
                                label: '不需要',
                                value: 1
                            }]
                        }, {
                            label: "紧急服务备注",
                            prop: "emergencyServicesRemarks",
                            bind: 'order.emergencyServicesRemarks',
                        },
                        // {
                        //     label: "案情概述",
                        //     prop: "summarize",
                        //     bind: 'order.summarize',
                        //     type: "textarea",
                        //     span: 24,
                        //     rules: [{
                        //         required: true,
                        //         message: "请填写",
                        //         trigger: "blur"
                        //     }]
                        // },
                        // {
                        //     label: "案情详情",
                        //     prop: "detail",
                        //     bind: 'order.detail',
                        //     type: "textarea",
                        //     span: 24,
                        //     rules: [{
                        //         required: true,
                        //         message: "请填写",
                        //         trigger: "blur"
                        //     }]
                        // },
                    ]
                }, {
                    label: '公检法相关凭证',
                    prop: 'gjf',
                    display: false,
                    column: [{
                        labelPosition: 'top',
                        prop: 'gjfpz',
                        formslot: true,
                        span: 24
                    }]
                }]
            },
            addForm: {},
            addVisible: false,
            isAsync: true, // 是否同步
            query: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            taskVisible: false,
            radderShow: true,
            personalWorkTypeData: [],
            radderCntIndex: 0,
            radderDoneCntIndex: 0
        }
    },
    created () {
        this.type = this.$route.query.type
        if (this.$route.query.id) {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters(["userInfo", "permission"]),
        getDateFormate () {
            return function (date) {
                return dateFormat(new Date(date), "yyyy-MM-dd")
            }
        },
        permissionList () {
            return {
                addBtn: this.vaildData(this.permission.order_add, false),
                viewBtn: this.vaildData(this.permission.order_update, false),
                delBtn: this.vaildData(this.permission.order_del, false),
                detailBtn: this.vaildData(this.permission.order_detail, false),
                importBtn: this.vaildData(this.permission.order_import, false),
                exportBtn: this.vaildData(this.permission.order_export, false),
                dispatchBtn: this.vaildData(this.permission.order_dispatch, false),
                taskBtn: this.vaildData(this.permission.order_task, false),
                regionBtn: this.vaildData(this.permission.order_region, false)
            };
        },
        ids() {
            let ids = [];
            this.selectionList.forEach(ele => {
                ids.push(ele.id);
            });
            return ids.join(",");
        }
    },
    mounted() {
        let column1 = this.findObject(this.addOption.group, 'crimeType')
        let column2 = this.findObject(this.option.group, 'crimeType')
        let column3 = this.findObject(this.option.group, 'orderCreateDept')
        let column5 = this.findObject(this.option.group, 'type1')
        let column6 = this.findObject(this.addOption.group, 'type')
        let column7 = this.findObject(this.addOption.group, 'orderCreateDept')
        column3.disabled = this.userInfo.account !== 'admin'
        column7.disabled = this.userInfo.account !== 'admin'
        getDictTree().then(res => {
            let list = res.data.data.filter(v => v.code == 'crime_types')[0].children
            let list1 = res.data.data.filter(v => v.code == 'work_type')[0].children
            column1.dicData = list
            column2.dicData = list
            column5.dicData = list1
            column6.dicData = list1
        })
    },
    methods: {
        cellClassName ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 5) {
                return 'row-' + row.orderColor
            }
        },
        addDialogCloseHandle() {
            this.$refs.addform.resetForm()
            this.addVisible = false
        },
        asyncAddress(val) {
            if (val) {
                this.orderForm.actualResidenceProvince = this.orderForm.residenceProvince
                this.orderForm.actualResidentialAddress = this.orderForm.residenceAddress
                setTimeout(() => {
                    this.orderForm.actualResidenceCity = this.orderForm.residenceCity
                    setTimeout(() => {
                        this.orderForm.actualResidenceDistrict = this.orderForm.residenceDistrict
                    }, 150)
                }, 150)
            }
        },
        // 新增输入身份证后档案信息有是否同步过来
        ayscHandle() {
            if (this.isAsync && !this.orderForm.id && !cardid(this.orderForm.orderPersonalData.cardNo)[0] && this.orderForm.orderPersonalData.name) {
                getArchivesDetailByCardId(this.orderForm.orderPersonalData.cardNo).then(res => {
                    let dossier = res.data.data
                    if (dossier.basisArchivePersonalData && dossier.basisArchivePersonalData.id) {
                        this.$confirm("是否要同步基础档案的信息").then(() => {
                            getDetail(dossier.basisArchivePersonalData.residenceRegionCode).then(data => {
                                dossier.basisArchivePersonalData.residenceProvince = data.data.data.provinceCode
                                dossier.basisArchivePersonalData.residenceCity = data.data.data.cityCode
                                dossier.basisArchivePersonalData.residenceDistrict = data.data.data.districtCode
                                getDetail(dossier.basisArchivePersonalData.actualResidenceRegionCode).then(data2 => {
                                    dossier.basisArchivePersonalData.actualResidenceProvince = data2.data.data.provinceCode
                                    dossier.basisArchivePersonalData.actualResidenceCity = data2.data.data.cityCode
                                    dossier.basisArchivePersonalData.actualResidenceDistrict = data2.data.data.districtCode
                                    this.isAsync = false
                                    this.orderForm.orderPersonalData = dossier.basisArchivePersonalData
                                    // delete this.orderForm.dossier.id
                                    // delete this.orderForm.dossier.dossierNo
                                })
                            })
                        }).catch(() => {
                            this.isAsync = false
                        })
                    }

                })
            }
        },
        handleDelete() {
            if (this.selectionList.length === 0) {
                this.$message.warning("请选择至少一条数据");
                return;
            }
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    return remove(this.ids);
                })
                .then(() => {
                    // 刷新表格数据并重载
                    this.data = [];
                    this.$refs.crud.toggleSelection();
                    // 表格数据重载
                    this.onLoad(this.page);
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        // 下载pdf 文件
        downLoadPdf (row) {
            getOrderInfo(row.id).then(res => {
                this.pdfOnlinelVisible = true
                this.detailInfo = res.data.data
            })
            // this.$message.success("下载pdf文件在线预览")
        },
        // 获取亲属关系回调
        getKinshipHandle (list) {
            this.$set(this.orderForm, 'orderKinshipList', list)
        },
        getjudicialHandle(list) {
            this.$set(this.orderForm, 'starOrderJudicialList', list)
        },
        getorderInitialPlanList(list) {
            this.$set(this.orderForm, 'orderInitialPlanList', list)
        },
        getRelationHandle(list) {
            this.$set(this.orderForm, 'orderRelationList', list)
        },
        handleSuccessView2(row, type) {
            this.$router.push({ path: '/order/detail/test', query: { id: row.id, type: type } });
        },
        handleSuccessView (row) {
            this.$router.push({ path: '/order/detail/success', query: { id: row.id } });
        },
        error() {
            this.$message.success('请填写完整信息');
        },
        initTree() {
            this.treeData = [];
            getLazyTree("00").then(res => {
                this.treeData = res.data.data.map(item => {
                    return {
                        ...item,
                        leaf: !item.hasChildren
                    }
                })
            });
        },
        // 搜索重置事件
        searchReset () {
            this.query = {};
            this.onLoad(this.page);
        },
        // 搜索事件
        searchChange (params, done) {
            params['orderCardNo'] = this.personalData.orderCardNo
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad(this.page, params);
            done();
        },
        // 选择框事件
        selectionChange (list) {
            this.selectionList = list;
        },
        // 选择框清除事件
        selectionClear () {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
        },
        // 改变页码事件
        currentChange (currentPage) {
            this.page.currentPage = currentPage;
        },
        // 每页数量变化事件
        sizeChange (pageSize) {
            this.page.pageSize = pageSize;
        },
        // 刷新事件
        refreshChange () {
            this.onLoad(this.page, this.query);
        },
        // 获取列表数据事件
        onLoad (page, params = {}) {
            const { timeRange } = this.query;
            let values = {
                ...params,
                orderCardNo: this.personalData.orderCardNo
            };
            if (timeRange) {
                values = {
                    ...params,
                    startTime: timeRange[0],
                    endTime: timeRange[1],
                    ...this.query
                };
                values.timeRange = null;
            }
            this.loading = true;
            getList(page.currentPage, page.pageSize, Object.assign(values)).then(res => {
                if (res.data.data.records.length > 0) {
                    res.data.data.records.map(v => {
                        v.orderType = v.type
                    })
                }
                this.data = res.data.data.records;

                this.page.total = res.data.data.total;
                this.loading = false;
                this.selectionClear();
            });
        },
        // 导出用户数据
        handleExport () {
            this.$confirm("是否导出订单数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let str = serialize(emptySurplus({
                    ids: this.ids, ...this.search,
                    orderCardNo: this.personalData.orderCardNo
                }))
                if (str) {
                    str = "&" + str
                }
                window.open(`/api/blade-sorder/starorder/export?${this.website.tokenHeader}=${getToken()}${str}`);
            });
        },
        rowSave (form, done) {
            let obj = { ...form.order };
            obj.orderPersonalData = form.orderPersonalData
            obj.starOrderJudicialList = this.orderForm.starOrderJudicialList
            obj.orderCreateDeptName = form.$orderCreateDept
            obj.orderCreateUserName = form.$orderCreateUser
            obj.crimeTime = form.crimeTime
            obj.placeType = form.placeType
            this.setCityHandle(obj, this.orderForm)
            if (obj.orderPersonalData.id) {
                delete obj.orderPersonalData.id
            }
            let arr = form.regionCode
            let newCode = arr.pop()
            obj.regionCode = newCode
            add(obj).then((res) => {
                console.log(res)
                // 获取新增数据的相关字段
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                done()
                this.orderForm = {}
                this.$refs.addform.resetForm()
                this.addVisible = false
                this.refreshChange()
                // 数据回调进行刷新
            }, error => {
                done()
                this.orderForm = {}
                this.$refs.addform.resetForm()
                this.addVisible = false
                window.console.log(error);
            });
        },
        rowUpdate (form, index, done, loading) {
            let arr = form.regionCode
            let newCode = arr.pop()
            let obj = {
                id: this.orderForm.id,
                orderCreateUser: form.orderCreateUser,
                orderCreateDept: form.orderCreateDept,
                orderCreateUserName: form.$orderCreateUser,
                orderCreateDeptName: form.$orderCreateDept,
                regionCode: newCode,
                type: form.type1,
                orderColor: form.orderColor1,
                crimeType: form.crimeType,
                crimeTime: form.crimeTime,
                placeType: form.placeType,
                crimeSituation: form.crimeSituation,
                hazard: form.hazard,
                hazardRemark: form.hazardRemark,
                emergencyServices: form.emergencyServices,
                emergencyServicesRemarks: form.emergencyServicesRemarks,
                summarize: form.summarize,
                detail: form.detail,
                performance: form.performance,
                expectations: form.expectations,
                support: form.support,
                opinion: form.opinion,
                orderPersonalData: form.orderPersonalData,
                orderSocialSurvey: form.orderSocialSurvey,
            }
            this.setCityHandle(obj, this.orderForm)
            update(obj).then(() => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                if (this.orderForm.orderSocialSurvey.id) {
                    this.refreshCity()
                } else {
                    getOrderInfo(this.orderForm.id).then(res => {
                        this.orderForm.orderSocialSurvey.id = res.data.data.orderSocialSurvey.id
                        console.log(res.data.data);
                    })
                }
                // 数据回调进行刷新
                this.refreshChange()
                loading()
            }, error => {
                window.console.log(error);
                loading()
            });
        },
        setCityHandle (obj, form) {
            this.$set(obj.orderPersonalData, "residenceRegionCode", form.orderPersonalData.residenceDistrict || form.orderPersonalData.residenceCity || form.orderPersonalData.residenceProvince)
            this.$set(obj.orderPersonalData, "actualResidenceRegionCode", form.orderPersonalData.actualResidenceDistrict || form.orderPersonalData.actualResidenceCity || form.orderPersonalData.actualResidenceProvince)
            this.$set(obj.orderPersonalData, "residenceProvince", form.$residenceProvince)
            this.$set(obj.orderPersonalData, "residenceCity", form.$residenceCity)
            this.$set(obj.orderPersonalData, "residenceDistrict", form.$residenceDistrict)
            this.$set(obj.orderPersonalData, "actualResidenceProvince", form.$actualResidenceProvince)
            this.$set(obj.orderPersonalData, "actualResidenceCity", form.$actualResidenceCity)
            this.$set(obj.orderPersonalData, "actualResidenceDistrict", form.$actualResidenceDistrict)
        },
        refreshCity () {
            this.$set(this.orderForm.orderPersonalData, "residenceRegionCode", this.orderForm.residenceDistrict || this.orderForm.residenceCity || this.orderForm.residenceProvince)
            this.$set(this.orderForm.orderPersonalData, "actualResidenceRegionCode", this.orderForm.actualResidenceDistrict || this.orderForm.actualResidenceCity || this.orderForm.actualResidenceProvince)
            this.$set(this.orderForm.orderPersonalData, "residenceProvince", this.orderForm.residenceProvince)
            this.$set(this.orderForm.orderPersonalData, "residenceCity", this.orderForm.residenceCity)
            this.$set(this.orderForm.orderPersonalData, "residenceDistrict", this.orderForm.residenceDistrict)
            this.$set(this.orderForm.orderPersonalData, "actualResidenceProvince", this.orderForm.actualResidenceProvince)
            this.$set(this.orderForm.orderPersonalData, "actualResidenceCity", this.orderForm.actualResidenceCity)
            this.$set(this.orderForm.orderPersonalData, "actualResidenceDistrict", this.orderForm.actualResidenceDistrict)
        },
        // 打开新增弹框
        handleAdd() {
            this.isAsync = true
            setTimeout(() => {
                this.orderForm.orderCreateDept = this.userInfo.dept_id
                this.orderForm.orderCreateUser = this.userInfo.user_id
                this.orderForm.orderPersonalData.orderCreateDept = this.userInfo.dept_id
                this.orderForm.orderPersonalData.orderCreateUser = this.userInfo.user_id
                // this.isChange = false
            }, 300)
            this.addVisible = true
        },
        // 打开编辑弹框
        handleEdit (row) {
            this.getOrderDetail(row.id).then(res => {
                this.orderForm.orderColor1 = res.orderColor
                res.orderColor1 = res.orderColor
                getDetail(res.orderPersonalData.residenceRegionCode).then(data => {
                    this.$set(this.orderForm.orderPersonalData, 'residenceProvince', data.data.data.provinceCode)
                    this.$set(this.orderForm, 'residenceProvince', data.data.data.provinceCode)
                    setTimeout(() => {
                        this.$set(this.orderForm.orderPersonalData, 'residenceCity', data.data.data.cityCode)
                        this.$set(this.orderForm, 'residenceCity', data.data.data.cityCode)
                        setTimeout(() => {
                            this.$set(this.orderForm.orderPersonalData, 'residenceDistrict', data.data.data.districtCode)
                            this.$set(this.orderForm, 'residenceDistrict', data.data.data.districtCode)
                        }, 100)
                    }, 100)
                    getDetail(res.orderPersonalData.actualResidenceRegionCode).then(data2 => {
                        this.$set(this.orderForm.orderPersonalData, 'actualResidenceProvince', data2.data.data.provinceCode)
                        this.$set(this.orderForm, 'actualResidenceProvince', data2.data.data.provinceCode)
                        setTimeout(() => {
                            this.$set(this.orderForm.orderPersonalData, 'actualResidenceCity', data2.data.data.cityCode)
                            this.$set(this.orderForm, 'actualResidenceCity', data2.data.data.cityCode)
                            setTimeout(() => {
                                this.$set(this.orderForm.orderPersonalData, 'actualResidenceDistrict', data2.data.data.districtCode)
                                this.$set(this.orderForm, 'actualResidenceDistrict', data2.data.data.districtCode)
                            }, 100)
                        }, 100)
                        if (this.orderForm.regionCode) {
                            getDetail(this.orderForm.regionCode).then(data3 => {
                                let arr = data3.data.data.ancestors.split(",")
                                arr.push(data3.data.data.code)
                                arr.splice(0, 1)
                                this.orderForm.regionCode = arr
                                this.$refs.crud.rowEdit(res)
                            })
                        } else {
                            this.$refs.crud.rowEdit(res)
                        }
                    })
                })
            })
        },
        getOrderDetail (id) {
            return new Promise((reslove) => {
                getOrderInfo(id).then(res => {
                    let dossier = res.data.data;
                    dossier.type1 = dossier.type
                    this.orderForm = dossier
                    reslove(this.orderForm)
                })
            })
        },
        // 查看详情
        handleView (row, index) {
            this.isMode = index
            getOrderInfo(row.id).then(res => {
                this.orderDetailVisible = true
                this.detailInfo = res.data.data
            })
        },
        // 任务
        handleJudicial (row) {
            getOrderInfo(row.id).then(res => {
                this.taskVisible = true
                this.detailInfo = res.data.data
            })
        },
        // 打印初始计划单
        printInitHandle () {
            if (this.orderForm.orderInitialPlanList && this.orderForm.orderInitialPlanList.length > 0) {
                this.pdflVisible = true
            } else {
                this.$message.error("请填写初始计划单")
            }
        },
        // 生成初始计划单并审核
        goToExamine () {
            if (this.orderForm.orderInitialPlanList && this.orderForm.orderInitialPlanList.length <= 0) {
                this.$message.error("请先填写初始计划单")
            } else {
                this.$confirm('提交总中心审核, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = {
                        id: this.orderForm.id,
                        orderCreateUser: this.orderForm.orderCreateUser,
                        orderCreateDept: this.orderForm.orderCreateDept,
                        type: this.orderForm.type1,
                        orderColor: this.orderForm.orderColor1,
                        crimeType: this.orderForm.crimeType,
                        crimeSituation: this.orderForm.crimeSituation,
                        hazard: this.orderForm.hazard,
                        hazardRemark: this.orderForm.hazardRemark,
                        emergencyServices: this.orderForm.emergencyServices,
                        emergencyServicesRemarks: this.orderForm.emergencyServicesRemarks,
                        summarize: this.orderForm.summarize,
                        detail: this.orderForm.detail,
                        performance: this.orderForm.performance,
                        expectations: this.orderForm.expectations,
                        support: this.orderForm.support,
                        opinion: this.orderForm.opinion,
                        orderPersonalData: this.orderForm.orderPersonalData,
                        orderSocialSurvey: this.orderForm.orderSocialSurvey,
                    }
                    this.setCityHandle(obj, this.orderForm)
                    update(obj).then(() => {
                        auditPlanHandle(this.orderForm.id).then(res => {
                            console.log(res)
                            this.$message.success("已提交审核")
                            this.$refs.crud.closeDialog()
                            this.refreshChange()
                        })
                    }, error => {
                        window.console.log(error);
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        },
        openSocialHandle() {
            if (this.orderForm.orderSocialSurvey.id) {
                this.pdflVisible1 = true
            } else {
                this.$message.error("请先完善社会调查内容")
            }
        },
        lazyLoad (node, resolve) {
            let stop_level = 4;
            let level = node.level;
            let list = []
            let callback = () => {
                resolve((list || []).map(ele => {
                    return Object.assign(ele, {
                        leaf: level >= stop_level
                    })
                }));
            }
            getLazyTree(level == 0 ? "00" : node.value).then(res => {
                if (level == 0) {
                    list = res.data.data.filter(v => v.value == "35")
                } else {
                    list = res.data.data;
                }
                callback()
            });
        },
        updateRegionHandle (row) {
            this.deptotion.orderId = row.id
            this.updateOrderVisible = true;
        },
        changeHandle (value) {
            if (!value) {
                return
            }
            getDetail(value).then(res => {
                this.deptotion.regionalLevel = res.data.data.regionLevel
            })
            getDeptListByRegionCode(value).then(res => {
                this.deptList = res.data.data
            })
        },
        perfectHandle () {
            if (!this.deptotion.regionalCode) {
                this.$message.error('请选择区域')
                return;
            }
            if (!this.deptotion.improveDept) {
                this.$message.error('请选择机构')
                return;
            }
            perfectRegional(this.deptotion).then(res => {
                console.log(res)
                this.$message.success('已提交')
                this.updateOrderVisible = false;
                this.refreshChange()
            })
        },
        // 查询某个身份证号对应人员的订单类型统计
        loadPersonalWorkTypeDataWay (id) {
            personalWorkTypeData({
                idcard: id
            }).then(res => {
                this.personalWorkTypeData = res.data.data;
                // console.log("查询某个身份证号对应人员的订单类型统计",res.data.data);
            })
        },
        // 查询某个身份证号对应人员的具体计划的参与机构统计数据
        loadSpecificPlanDataWay (id) {
            specificPlanData({
                idcard: id
            }).then(res => {
                // this.personalWorkTypeData = res.data.data;
                // console.log("查询某个身份证号对应人员的具体计划的参与机构统计数据", res.data.data);
                if (res.data.data == "") {
                    this.radderShow = false;
                    return;
                }
                this.radderShow = true;
                let returnData = {
                    radarNmae: [],
                    cntData: [],
                    doneCntData: []
                }
                for (var key in res.data.data) {
                    let radarNmae = {
                        name: ""
                    }
                    radarNmae.name = res.data.data[key].deptName
                    returnData.radarNmae.push(radarNmae);
                    returnData.cntData.push(res.data.data[key].cnt);
                    returnData.doneCntData.push(res.data.data[key].doneCnt);
                    this.radderCntIndex += res.data.data[key].cnt;
                    this.radderDoneCntIndex += res.data.data[key].doneCnt;
                }
                this.$refs.radder.setOptions(returnData);
                // console.log("查询某个身份证号对应人员的具体计划的参与机构统计数据",returnData);
            })
        },
        changeIdcard () {
            this.idCardType = !this.idCardType
        },
        async getDictByValue (key, value, code, type) {
            let res = await getDictionary({ code: code })
            let obj = res.data.data.find(v => v.dictKey == value)
            if (!obj) return
            if (type == 1) {
                this.$set(this.personalData, key, obj.dictValue)
            } else {
                this.$set(this.personalData.orderPersonalData, key, obj.dictValue)
            }

        },
        getDetail () {
            getOrderInfo(this.$route.query.id).then(res => {
                this.personalData = res.data.data
                this.jtjhDetail = this.personalData
                // console.log("当前data",this.personalData);

                this.loadPersonalWorkTypeDataWay(this.personalData.orderCardNo);
                this.loadSpecificPlanDataWay(this.personalData.orderCardNo);

                this.getDictByValue('type', this.personalData.type, 'work_type', 1)
                this.getDictByValue('status', this.personalData.status, 'order_status', 1)

                this.getDictByValue('gender', this.personalData.orderPersonalData.gender, 'sex', 2)
                this.getDictByValue('crimeType', this.personalData.crimeType, 'crime_types', 1)
                getDictionary({ code: 'order_status' }).then(res => {
                    this.starOrderStatusList = res.data.data
                })
                setTimeout(() => {
                    this.init()
                }, 200)

            })
        },
        init () {
            this.text = `https://` + window.location.host + `/mobile/#/home?id=${this.personalData.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'
            this.qrcode = new QRCode("#qrcode", {
                text: this.text,
                linearGradient: true,
                linearGradientDirection: 'to bottom right',
                linearGradientFrom: '#E2AE28',
                linearGradientTo: '#40948A',
                linearGradientMiddle: '#E3821B',
                linearGradientMiddle2: '#6EB691'
            });
            this.timer = setInterval(() => {
                this.refreshQrcodeHandle()
            }, 60000);
        },
        refreshQrcodeHandle () {
            this.text = `https://` + window.location.host + `/mobile/#/home?id=${this.personalData.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'
            this.qrcode.makeCode(this.text)
        },
        getCaseArchivedDetail () {
            getArchivesDetailByOrderId(this.personalData.id).then(res => {
                this.caseDetail = res.data.data.starOrder
                this.dosserId = res.data.data.id
                this.orderDetailVisible1 = true
            })
        }
    },

}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/order.scss";
</style>
<style lang="scss">
.order-detail canvas {
    width: 100% !important;
    height: 100% !important;
}

.order-list-item {
    display: flex;
    margin-top: 20px;

    .item {
        flex: 1;
        text-align: center;

        .pain {
            width: 70px;
            line-height: 30px;
            border: 1px solid #eaeaea;
            margin: 0 auto 10px;
        }

        .btn {
            width: 90px;
            line-height: 30px;
            background: #00cd66;
            color: #fff;
            margin: 0 auto;

            &.two {
                background: #0733ff;
            }

            &.three {
                background: #e37b17;
            }
        }
    }
}
</style>
